import React from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { Card, Button } from '../UI';
import classes from './ProjectDetailPage.module.css';
import { parseDateToEpoch } from '../../utils/parseDateToEpoch';

const ProjectDevicesTable = ({ devices, loading, selectedRows, clearSelectedRows, onRowSelected, onDownloadSelected, onDownloadRow, onRemoveSelected }) => {
  const navigate = useNavigate();

  const columns = [
    { 
      name: 'Serial number', 
      selector: row => row.serialNumber || '', 
      sortable: true, 
      style: { fontSize: '15px', whiteSpace: 'nowrap' },
      wrap: false,
      minWidth: '180px'
    },
    { 
      name: 'Device EUI', 
      selector: row => row.deviceEUI || '', 
      sortable: true, 
      style: { fontSize: '14px', whiteSpace: 'nowrap' },
      wrap: false,
      minWidth: '180px'
    },
    { 
      name: 'Device model', 
      selector: row => row.deviceModel || '', 
      sortable: true, 
      style: { fontSize: '14px' },
      wrap: true,
      minWidth: '200px'
    },
    { 
      id: 'dateAdded',
      name: 'Date added', 
      selector: row => parseDateToEpoch(row.dateAdded),
      cell: row => row.dateAdded || '',
      sortable: true, 
      style: { fontSize: '14px' },
      wrap: true,
      minWidth: '120px'
    },
    {
      name: '',
      cell: (row) => (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDownloadRow(row);
          }}
          className={classes.downloadButton}
        >
          Download
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '120px',
      minWidth: '120px'
    }
  ];

  return (
    <Card padding="small">
      <div className={classes.selectedActions}>
        <Button
          variant="primary"
          onClick={onRemoveSelected}
          disabled={loading || selectedRows.length === 0}
          className={classes.selectedButton}
        >
          Remove selected ({selectedRows.length})
        </Button>
        <Button
          variant="primary"
          onClick={onDownloadSelected}
          disabled={loading || selectedRows.length === 0}
          className={classes.selectedButton}
        >
          Download selected ({selectedRows.length})
        </Button>
      </div>
      <div className={classes.tableContainer}>
        <DataTable
          columns={columns}
          data={devices}
          progressPending={loading}
          noHeader={true}
          pagination={true}
          highlightOnHover={true}
          striped={true}
          selectableRows={true}
          clearSelectedRows={clearSelectedRows}
          onSelectedRowsChange={onRowSelected}
          noDataComponent="No devices found in this project"
          defaultSortFieldId="dateAdded"
          defaultSortAsc={false}
          onRowClicked={(row) => navigate(`/devices/${row.id}`)}
          pointerOnHover={true}
          customStyles={{
            headCells: { 
              style: { 
                fontWeight: 'bold', 
                fontSize: '15px',
                whiteSpace: 'nowrap',
                overflow: 'visible',
                textOverflow: 'clip',
                paddingLeft: '8px',
                paddingRight: '8px'
              }
            },
            cells: {
              style: {
                fontSize: '14px'
              }
            }
          }}
        />
      </div>
    </Card>
  );
};

export default ProjectDevicesTable;

